import React, { useState } from 'react';
import { Popover } from 'antd';
import { useQueryClient } from 'react-query';

import { LockOutlined } from '@ant-design/icons';

import { StyledButton } from '../../components/Button';
import { DetailsHeaderButton } from '../../components/DetailsHeaderActions';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import Icon, { iconColors } from '../../icons/Icon';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { useAnonymiseData } from './useAnonymiseData';

export const AnonymiseButton: React.FC<{ candidateId: string }> = ({ candidateId }) => {
  const anonymiseData = useAnonymiseData();
  const queryClient = useQueryClient();

  const [openPopover, setOpenPopover] = useState(false);

  const handleAnonymise = () => {
    anonymiseData.mutate(
      { queryParams: { id: candidateId } },
      {
        onSuccess: () => queryClient.invalidateQueries([pathToUrl(ApiRoutesEnum.getCandidate, { id: candidateId })]),
      }
    );
    setOpenPopover(false);
  };

  const clickWhenPopoverOpenedHandler = () => {
    if (openPopover) {
      setOpenPopover(false);
      window.removeEventListener('click', clickWhenPopoverOpenedHandler);
    }
  };

  const AnonymisePopoverContent: React.FC = () => (
    <StyledColumn width="400px">
      <div>Do you confirm anonymising candidate private data like:</div>
      <StyledColumn gap="0">
        <div>First name</div>
        <div>Last name</div>
        <div>Phone number</div>
        <div>Email address?</div>
      </StyledColumn>
      <div style={{ color: '#DE3A3A' }}>Warning! This action cannot be undone.</div>
      <StyledRow justifyContent="flex-end" marginTop="10px">
        <StyledButton type="default" onClick={handleAnonymise}>
          Confirm anonymisation
        </StyledButton>
        <StyledButton type="primary" onClick={() => setOpenPopover(false)}>
          Cancel
        </StyledButton>
      </StyledRow>
    </StyledColumn>
  );

  const Title: React.FC = () => {
    return (
      <StyledRow gap="0.5rem" justifyContent="flex-start">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon name="Lock" style={{ color: `${iconColors.black}` }} />
        </div>
        <div>Anonymization confirmation</div>
      </StyledRow>
    );
  };

  return (
    <Popover
      placement="bottomRight"
      title={<Title />}
      content={<AnonymisePopoverContent />}
      open={openPopover}
      trigger="click"
      afterOpenChange={() => window.addEventListener('click', clickWhenPopoverOpenedHandler)}
    >
      <DetailsHeaderButton danger icon={<LockOutlined aria-hidden />} onClick={() => setOpenPopover(true)}>
        Anonymise data
      </DetailsHeaderButton>
    </Popover>
  );
};
